import { render, staticRenderFns } from "./ScholarshipCurrentPayoutSingle.vue?vue&type=template&id=08e9ad29&"
import script from "./ScholarshipCurrentPayoutSingle.vue?vue&type=script&lang=js&"
export * from "./ScholarshipCurrentPayoutSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports